const getBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("sandbox") || hostname.includes("localhost")
    || hostname.includes("172.")
  ) {
    //return process.env.REACT_APP_TEST_URL;
    return process.env.REACT_APP_BASE_URL;
  } else {
    return process.env.REACT_APP_BASE_URL;
    //return process.env.REACT_APP_TEST_URL;
  }
};
const URL = getBaseUrl();
export default URL;
